module.exports = __webpack_public_path__ + "d084baa878fdb03888175acd74456eb1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-19.png
// module id = 3246
// module chunks = 0